document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-quantity-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    var minus = wrapper.querySelector('[data-quantity-minus]');
    var plus = wrapper.querySelector('[data-quantity-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      var min = parseInt(input.min || '1', 10);
      var value = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
      input.value = value;
    });
    plus && plus.addEventListener('click', function () {
      var value = (parseInt(input.value, 10) || 1) + 1;
      input.value = value;
    });
    input.addEventListener('change', function () {
      var min = parseInt(input.min || '1', 10);
      if (!input.value || parseInt(input.value, 10) < min) {
        input.value = min;
      }
    });
  });

  /* ---------- Reveal-on-scroll animation ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---------- Journal search + sort ---------- */
  var journalGrid = document.querySelector('[data-journal-grid]');
  if (journalGrid) {
    var journalSearch = document.querySelector('[data-journal-search]');
    var journalSort = document.querySelector('[data-journal-sort]');
    var journalNoResults = document.querySelector('[data-journal-no-results]');
    var journalCards = Array.prototype.slice.call(journalGrid.querySelectorAll('[data-journal-card]'));

    var applyJournalFilter = function () {
      var query = journalSearch ? journalSearch.value.trim().toLowerCase() : '';
      var visibleCount = 0;
      journalCards.forEach(function (card) {
        var title = (card.getAttribute('data-title') || '').toLowerCase();
        var isMatch = !query || title.indexOf(query) !== -1;
        card.style.display = isMatch ? '' : 'none';
        if (isMatch) visibleCount += 1;
      });
      if (journalNoResults) journalNoResults.hidden = visibleCount !== 0;
    };

    var applyJournalSort = function () {
      var value = journalSort ? journalSort.value : 'newest';
      var sorted = journalCards.slice();
      if (value === 'az') {
        sorted.sort(function (a, b) {
          return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        });
      } else {
        /* "popular" and "most-read" fall back to newest-first: Shopify
           themes have no built-in article view-count data source. */
        sorted.sort(function (a, b) {
          return parseInt(b.getAttribute('data-date'), 10) - parseInt(a.getAttribute('data-date'), 10);
        });
      }
      sorted.forEach(function (card) { journalGrid.appendChild(card); });
    };

    if (journalSearch) journalSearch.addEventListener('input', applyJournalFilter);
    if (journalSort) journalSort.addEventListener('change', applyJournalSort);
  }

  /* ---------- Article sticky table of contents ---------- */
  var tocList = document.querySelector('[data-toc-list]');
  var articleBody = document.querySelector('[data-article-body]');
  var tocWrap = document.querySelector('[data-article-toc]');
  if (tocList && articleBody && tocWrap) {
    var headings = articleBody.querySelectorAll('h2, h3');
    if (headings.length >= 2) {
      headings.forEach(function (heading, index) {
        if (!heading.id) heading.id = 'toc-heading-' + index;
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        if (heading.tagName === 'H3') link.className = 'article-toc__sub';
        tocList.appendChild(link);
      });
    } else {
      tocWrap.style.display = 'none';
    }
  }

  /* ---------- Subtle parallax on hero images ---------- */
  var parallaxEls = document.querySelectorAll('[data-parallax]');
  if (parallaxEls.length) {
    var onParallaxScroll = function () {
      parallaxEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var offset = rect.top * 0.1;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
    };
    window.addEventListener('scroll', onParallaxScroll, { passive: true });
    onParallaxScroll();
  }

  /* ---------- Product gallery thumbnails (click to swap main image) ---------- */
  var mainImage = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('[data-thumb]');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full-src');
        if (fullSrc) {
          mainImage.src = fullSrc;
        }
        thumbs.forEach(function (t) { t.removeAttribute('data-active'); });
        thumb.setAttribute('data-active', '');
      });
    });
  }
});
